import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const user = localStorage.getItem('user');

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  try {
    const userData = JSON.parse(user);

    // Check if token is expired
    if (userData.expires_at) {
      const expiresAt = new Date(userData.expires_at).getTime();
      if (Date.now() > expiresAt) {
        localStorage.removeItem('user');
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('okta_api_token');
        return <Navigate to="/login" state={{ from: location }} replace />;
      }
    }
  } catch {
    localStorage.removeItem('user');
    localStorage.removeItem('isAuthenticated');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default PrivateRoute;